import { render, staticRenderFns } from "./maintainlist.vue?vue&type=template&id=be80010c"
import script from "./maintainlist.vue?vue&type=script&lang=js"
export * from "./maintainlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports